import { Modal } from "antd";

function ErrorsTable(props: { open: any, close: any, title: any, headersErrors: any, listErrors: any }) {
  
  let rowsErrors = [];
        let errors = props.listErrors;
        for (let i=0; i<errors.length; i++) {
            let error = errors[i]["Error"];
            if(error)
            {
                error = error.split('|');             
            }

            let cells = [];
            let keys = Object.keys(errors[i]);
            keys = keys.filter(k => k !== "Error");
            let lengthKeys = keys.length; 
            for (let j=0; j<lengthKeys; j++) {

                let label = errors[i][keys[j]];

                let column = keys[j];
                debugger
                let td = <td className='table-errors-cell' >{label}</td>

                if(error && error.length > 0)
                {
                    let errorDetail = [];
                    for (let k=0; k<error.length; k++) {
                        errorDetail = error[k].split('#');
                        if(errorDetail.length === 2)
                        {
                            if(column === errorDetail[0])
                            {
                                td = <td  style={{backgroundColor:'#ff9494',color:'#FFFFFF', padding:'6px 5px', borderBottom:'1px solid #727f88'}} title={errorDetail[1]}>{label}</td>
                                break;
                            }
                        }
                    }
                }
                cells.push(td);
            }
            rowsErrors.push(<tr key={"error_"+i}>
                {cells}
            </tr>);
        }

  return (<Modal
    centered
    title={props.title}
    open={props.open}
    footer={null}
    maskClosable={true}
    className="modal-errors"
    zIndex={1000}
    closable={true}
    onCancel={props.close}
  >    <div>
        <table className="ant-table">
            <thead className="ant-table-thead">
                {props.headersErrors}
            </thead>
            <tbody>
                {rowsErrors}
              </tbody>
          </table>
      </div>
  </Modal>);
}

export default ErrorsTable;